/* eslint-disable import/prefer-default-export */
export const getLanguage = () => localStorage.getItem('locale') || 'DE';
